import styles from './sidebar-branches-accordion.module.css';
import { BranchWithParsedCases } from '@/app/lib/schemas/types/branch-types';
import { Flex } from '@radix-ui/themes';
import { Accordion } from 'radix-ui';
import {
  AccordionContent,
  AccordionTrigger
} from '@/app/ui/components/shared/accordion';
import SidebarNavItem from './sidebar-navigation-item';

interface Props {
  branches: BranchWithParsedCases[];
  pathname: string;
  onClick: () => void;
}

const SidebarBranchesAccordion = ({ branches, pathname, onClick }: Props) => {
  return (
    <Flex direction='column'>
      {branches.map(branch => (
        <Accordion.Item
          key={branch.slug}
          value={`/${branch.slug}`}
          className={styles.Item}
        >
          <AccordionTrigger>{branch.name}</AccordionTrigger>
          <AccordionContent>
            <ul className={styles.Sublist}>
              {branch.topics.map(topic => (
                <li
                  key={topic.slug}
                  className={
                    pathname.split('/').includes(topic.slug)
                      ? styles.Active
                      : undefined
                  }
                >
                  <SidebarNavItem
                    href={`/${branch.slug}/${topic.slug}`}
                    label={topic.name}
                    isActive={pathname.split('/').includes(topic.slug)}
                    onClick={onClick}
                  />
                </li>
              ))}
            </ul>
          </AccordionContent>
        </Accordion.Item>
      ))}
    </Flex>
  );
};

export default SidebarBranchesAccordion;
